import { createContext, useContext } from 'react';

export const OrderProductsStickyParentGroupSlotContext = createContext<HTMLElement | null>(null);

export const useOrderProductsStickyParentGroupSlot = () =>
  useContext(OrderProductsStickyParentGroupSlotContext);
